<ng-container *t="let t">
  <div class="inside-container">
    <div fxLayout="row">
      <div fxFlex="85" fxLayoutAlign="start center">
        <h3 class="tab-header" i18n="@@308233510382796132" t="308233510382796132">Diversity Details</h3>
        <a target="_blank" [href]="helpUrl" *ngIf="helpUrl">
          <tsl-icon size="small" class="header-help-icon" tooltip="Training" i18n-tooltip="@@4013060476269413412"
            #training tslTooltip="{{ t('4013060476269413412', training) }}">help</tsl-icon>
        </a>
      </div>
      <div class="right">
        <button type="button" tsl-button [disabled]="preventativeHold==true" ghost color="blue" class="right-align"
          name="btnEditDiversity" (click)="openEditDialog()">
          Edit Diversity Details
        </button>
      </div>
    </div>
    <br />
    <div *ngIf="supplierDiversity">
      <div class="row col-12">
        <div class="col-6">
          <div class="label-headers">Diversity Types</div>
          <ul class="form-group">
            <li *ngFor="let diveristy of selectedDiversityTypes">
              {{diveristy.Code}} - {{diveristy.Description}}
            </li>
          </ul>
        </div>

        <div class="col-6">
          <div class="label-headers">Percentage Of Ownership</div>
          <div class="form-group" *ngIf="supplierDiversity.ownershipPercentage?.newValue">
            {{ supplierDiversity.ownershipPercentage?.newValue }} %
          </div>
        </div>

      </div>
      <div class="row col-12">
        <div class="col-6">
          <div class="label-headers">Government Document Types</div>
          <div class="form-group">
            <ul class="form-group">
              <li *ngFor="let diveristy of selectGovernmentTypes">
                {{diveristy.Code}} - {{diveristy.Description}}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-6">
          <div class="label-headers">Council Document Types</div>
          <div class="form-group">
            <ul class="form-group">
              <li *ngFor="let diveristy of selectedAgencyTypes">
                {{diveristy.Code}} - {{diveristy.Description}}
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-container>